<template>
    
    <md-card> 
          <!-- <md-card-header class="md-card-header-icon">
            <div class="card-icon">
              <md-icon>design_services</md-icon>
            </div>
            <h4 class="title">
              Service Step
            </h4>
          </md-card-header> -->
          <md-card-content>
            <autoextra :collection="service" v-slot="{item,last,index}">
              <div class="columns" :class="{last: last}">
                <div class="md-layout md-gutter">
                  <div class="md-layout-item md-size-100">
                    <label class="label">{{last ? 'New ' : ''}}Service {{!last ? index + 1 : ''}}</label>
                    <span id="flagServiceType" style="display:none; color:red;">Field is required</span>
                  </div>
                  <div class="md-layout-item md-size-10">
                    <md-button class="md-primary md-round md-dense" v-on:click="findService(index)">Find Service</md-button>
                   </div>
                </div>

                <div class="md-layout md-gutter">
                  <input v-model="item.id" :readonly="true" type="hidden"/>
                  <input v-model="item.pkb_service_master_id" :readonly="true" type="hidden"/>

                  <!-- <div class="md-layout-item md-small-size-100">
                    <md-field class="md-invalid">
                      <label class="label" >Service Name</label>
                      <validation-provider  rules="servicename" ref="service_master_name"  v-slot="{ errors }">
                      <md-select v-model="item.pkb_service_master_id" @md-selected="onChangeService(index, $event)" @focus="focusSelectChanged(index)">
                        <md-option v-for="option in options_service_list" :key="option.value" :value="option.id">
                          {{ '('+option.service_master_code+') '+option.service_master_name }}
                        </md-option>
                      </md-select>
                      <span >{{ errors[0] }}</span>
                      </validation-provider>
                     
                    </md-field>
                  </div> -->

                  <div class="md-layout-item md-small-size-100">
                    <md-field >
                      <label class="label" >Service Name</label>
                        <validation-provider  ref="service_master_name"  v-slot="{ errors }">
                          <md-input  v-model="item.name" :readonly="true"/>
                          <span >{{ errors[0] }}</span>
                        </validation-provider>
                  
                    </md-field>
                  </div>

                  <div class="md-layout-item md-small-size-100">
                    <md-field >
                      <label class="label" >Service Code</label>
                      <md-input  v-model="item.code" :readonly="true"/>
                  
                    </md-field>
                  </div>
                  <div class="md-layout-item md-small-size-50">
                    <md-field >
                      <label class="label" >LTS</label>
                      <md-input  v-model="item.lts" :readonly="true"/>
                  
                    </md-field>
                  </div>
                  <div class="md-layout-item md-small-size-50">
                    <md-field >
                      <label class="label" >Discount(%)</label>
                      <md-input v-model="item.pkb_service_discount" @change="discountChange(index,item.pkb_service_discount)" type="text" v-on:keypress="NumbersOnly"/>
                  
                    </md-field>
                  </div>
                  <div class="md-layout-item md-small-size-50">
                    <md-field >
                      <label class="label" >Price</label>
                      <md-input  v-model="item.price" :readonly="true"/>
                  
                    </md-field>
                  </div>
                  <div class="md-layout-item md-small-size-50">
                    <md-field >
                      <label class="label" >Total</label>
                      <md-input  v-model="item.total" :readonly="true"/>
                  
                    </md-field>
                  </div>
                  <div class="md-layout-item md-small-size-100">
                    <md-field >
                      <label class="label" >Remarks</label>
                      <md-input  v-model="item.pkb_service_remark" />
                  
                    </md-field>
                  </div>
                  
                  <md-button class="md-danger md-dense" @click="deleteColumn(index)" v-if="item.code">
                    delete
                  </md-button>

                </div>            
              </div>
            </autoextra>
          </md-card-content>
           <modal ref="modalList" class="coba">
                    <template v-slot:header>
                      <h3>List Service</h3>
                    </template>

                    <template v-slot:body>
                      <list-service  :data_id="$refs.modalList.data"/>
                    </template>

                    <template v-slot:footer>
                      <md-card-actions>
                        <md-button @click="modalCloseList">
                          Close
                        </md-button>
                      </md-card-actions>
                    </template>
                </modal>
        </md-card>  
        
</template>
<script>
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
import  Autoextra  from 'vue-autoextra';
import {extend} from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import ListService from "@/pages/Dashboard/Workshop/PKB/ComponentForm/modal/ListService.vue";
import { Modal } from "@/components";

extend('servicename', {
  ...required,
  message: 'Please Select. Service is required'
  });

export default {
  name: "service-card",

  props: ['service_estimate'],
 components: { Autoextra, Modal, "list-service": ListService },

  mixins: [formMixin],

  data () {
    return {
      service: [],
      //options_service_list: null,
      index_modal: null,
    }
  },
  
  created() {
          this.onOpen()
      },
   methods:{
     //fungsi yang dipanggil saat page pertamakali dibuka
     async onOpen(){
      },

      NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },

     findService(index){
        this.index_modal = index
        this.$refs.modalList.openModal()
      },

      //fungsi untuk menutup modal list
      modalCloseList(data){
       console.log(data)
        this.$refs.modalList.closeModal()
        if(data.id){
           let error = document.getElementById("flagServiceType");
        error.style.display = "none"
          if(this.service[this.index_modal]){
          
            this.$set(this.service, this.index_modal, {
                id : this.service[this.index_modal].id,
                pkb_service_master_id : data.id,
                name : data.service_master_name,
                code : data.service_master_code,
                lts : data.service_master_lts,
                price : data.service_category_standard_cost,
                pkb_service_discount : this.service[this.index_modal].pkb_service_discount,
                total : (data.service_category_standard_cost * data.service_master_lts) - ((data.service_category_standard_cost * data.service_master_lts) * this.service[this.index_modal].pkb_service_discount/100),
                pkb_service_remark : this.service[this.index_modal].pkb_service_remark
              });
            }
            else{
              
            this.$set(this.service, this.index_modal, {
                id : null,
                pkb_service_master_id : data.id,
                name : data.service_master_name,
                code : data.service_master_code,
                lts : data.service_master_lts,
                price : data.service_category_standard_cost,
                pkb_service_discount : null,
                total : data.service_category_standard_cost * data.service_master_lts,
                pkb_service_remark : null
              });
            }
        }
        
      },

       //fungsi untuk menghapus row service
      deleteColumn(index){
        if (index > -1) {
          this.$delete(this.service, index,1)
          var filtered = this.service.filter(function (el) {
            return el != null;
          });
          this.service = filtered;
        }
        console.log(this.service);
        
      },
     

        //fungsi ketika ada perubahan di input discount, index nomor urut row
        discountChange(index,discount){
           //check apakah nilai discount tidak null
          if(discount){

            
             this.$set(this.service, index, {
                id : this.service[index].id,
                pkb_service_master_id : this.service[index].pkb_service_master_id,
                name : this.service[index].name,
                code : this.service[index].code,
                lts : this.service[index].lts,
                price : this.service[index].price,
                pkb_service_discount : discount,
                total : (this.service[index].price * this.service[index].lts) - ((this.service[index].price * this.service[index].lts) * discount/100),
                pkb_service_remark : this.service[index].pkb_service_remark
              });
          }

        },
        
     //fungsi yang di panggil dari sisi parent untuk mendapatkan data yang ada di page child ini    
    getData() {
        this.$emit('data', this.service)
    },
     //fungsi untuk mendapatkan data dari parent
     async getDataParent(data,type) {
        //loop untuk mengeset data row service
        if(type == 'add'){
          data.forEach((value, index) => {
          this.$set(this.service, index, {
            id : null,
            pkb_service_master_id : value.service_estimate_service_master_id,
            name : value.service_master_name,
            code : value.service_master_code,
            lts : value.service_master_lts,
            price : value.service_category_standard_cost,
            pkb_service_discount :  value.service_estimate_service_discount,
            total : (value.service_category_standard_cost * value.service_master_lts) - ((value.service_category_standard_cost * value.service_master_lts) * value.service_estimate_service_discount/100),
            pkb_service_remark : value.service_estimate_service_remark
          });

      });
        }
        else{
            data.forEach((value, index) => {
            this.$set(this.service, index, {
                id : value.id,
                pkb_service_master_id : value.pkb_service_master_id,
                name : value.service_master_name,
                code : value.service_master_code,
                lts : value.service_master_lts,
                price : value.service_category_standard_cost,
                pkb_service_discount :  value.pkb_service_discount,
                total : (value.service_category_standard_cost * value.service_master_lts) - ((value.service_category_standard_cost * value.service_master_lts) * value.pkb_service_discount/100),
                pkb_service_remark : value.pkb_service_remark
              });

          });
        }
       
       
    },
     //fungsi yang di panggil dari sisi parent untuk mengecheck validasi form di page child ini
   async validateForm() {
            const service_master_name = this.$refs['service_master_name'];
          let result = []
            //   if(this.service.length == 0){
            // result.push(
            //     await service_master_name.validate().then(function(data){
            //     return data.valid
            //     })
            // )
            //   }
            
            if(Object.keys(this.service).length != 0){
              if(!this.service[0].pkb_service_master_id){
                document.getElementById("flagServiceType").style.display = "block"
              result.push(false)
                }
              }

            if(Object.keys(this.service).length == 0){
                    document.getElementById("flagServiceType").style.display = "block"
                    result.push(false)
              }
            
            return result.every(Boolean)
          
    }
        

    },
    mounted() {
        console.log('Component mounted.')
    }
};
</script>

<style lang="scss" scoped>
.columns{
  margin-bottom: 3ex;
  border-bottom: 5px solid black;
}

.coba{
  width:800px !important;
  margin: 50px auto !important;
  
  @media screen and (max-width: 992px) {
      width: 90% !important;
    }
}
</style>
